import { Navigate, useLocation } from 'react-router-dom'
import type { UserRole } from '@rutatec/shared-types'
import { useAuthStore } from '@/store/auth.store'

interface AuthGuardProps {
  /** Se omitido, qualquer usuário autenticado pode acessar */
  allowedRoles?: UserRole[]
  children: React.ReactNode
}

/**
 * Guarda de autenticação e autorização por role.
 * Redireciona para /login se não autenticado.
 * Redireciona para /login se role não autorizado (com mensagem de erro).
 */
export const AuthGuard: React.FC<AuthGuardProps> = ({ allowedRoles, children }) => {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Role não autorizado → redireciona para login com aviso
    return <Navigate to="/login" state={{ unauthorized: true }} replace />
  }

  return <>{children}</>
}
